import type {Directive} from "vue";

interface LazyBackgroundState {
	url: string | undefined;
	loaded: boolean;
	observer: IntersectionObserver | null;
}

const states = new WeakMap<HTMLElement, LazyBackgroundState>();

const apply = (el: HTMLElement, url: string | undefined): void => {
	el.style.backgroundImage = url ? `url("${url.replace(/"/g, '%22')}")` : '';
};

export const vLazyBackground: Directive<HTMLElement, string | undefined> = {
	mounted(el, binding) {
		const state: LazyBackgroundState = {url: binding.value, loaded: false, observer: null};
		states.set(el, state);

		if (!('IntersectionObserver' in window)) {
			state.loaded = true;
			apply(el, state.url);
			return;
		}

		state.observer = new IntersectionObserver((entries) => {
			if (entries.some((entry) => entry.isIntersecting)) {
				state.observer?.disconnect();
				state.observer = null;
				state.loaded = true;
				apply(el, state.url);
			}
		}, {rootMargin: '300px 100% 300px 100%'});
		state.observer.observe(el);
	},
	updated(el, binding) {
		const state = states.get(el);
		if (!state) {
			return;
		}
		state.url = binding.value;
		if (state.loaded) {
			apply(el, state.url);
		}
	},
	unmounted(el) {
		states.get(el)?.observer?.disconnect();
		states.delete(el);
	},
};
